import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { AllCheckerCheckbox, Checkbox, CheckboxGroup } from '../../components/Checkbox';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import { AuthContext } from '../../navigation/AuthProvider';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import CustomModal from '../../components/modal/CustomModal';
import DaumPostcode from 'react-daum-postcode';
import AdvertiseController, { SectorType } from '../../controller/AdvertiseController';
import { useToast } from '../../controller/ToastController';
import { useOutletContext } from 'react-router-dom';

const AdvertiseCategory = () => {
  const [sector, setSector] = useState<SectorType[]>([]);
  const [selectedSector, setSelectedSector] = useState<SectorType[]>([]);
  const showToast = useToast();

  const maxLength = 2;

  const { currentStore } = useOutletContext<CurrentStoreContext>();

  // 초기 선택 체크박스 선정
  const checkCheckedSector = (sectorList: SectorType[]) => {
    let sectorTemp: SectorType[] = [];
    sectorList.map((sector: SectorType) => {
      sector.sector_list.map((item: SectorType) => {
        if (item.is_check) {
          sectorTemp.push(item);
        }
      });
    });
    setSelectedSector([...sectorTemp]);
  };

  // 체크박스 클릭
  const handleCheckboxChange = (subItem: SectorType) => {
    let sectorTemp: SectorType[] = selectedSector;

    if (sectorTemp.some((item) => item.parent_store_sector_id !== subItem.parent_store_sector_id))
      sectorTemp = [];
    if (sectorTemp.some((item) => item.store_sector_id === subItem.store_sector_id)) {
      sectorTemp = sectorTemp.filter((item) => item.store_sector_id !== subItem.store_sector_id);
    } else {
      if (sectorTemp.length < maxLength) {
        sectorTemp.push(subItem);
      } else {
        showToast('두 개 이상의 카테고리를 선택할 수 없어요.', 'error');
      }
    }
    // console.log('handleCheckboxChange', sectorTemp, subItem);

    setSelectedSector([...sectorTemp]);
  };

  // API 호출
  const getSector = async () => {
    try {
      const oRes = await AdvertiseController.getSector(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getSector', oResponse);
        if (oResponse.data) {
          setSector([...oResponse.data]);
          checkCheckedSector(oResponse.data);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const submitSector = async () => {
    try {
      const selectedSectorList: any = [];
      selectedSector.map((item: SectorType) => {
        selectedSectorList.push({
          parent_store_sector_id: item.parent_store_sector_id,
          store_sector_id: item.store_sector_id,
        });
      });
      console.log(selectedSectorList);
      const oRes = await AdvertiseController.setSector(currentStore.value, selectedSectorList);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        if (oResponse.ok) {
          showToast('카테고리를 변경했어요.');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getSector();
  }, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>카테고리 선택</h4>
              <h5>(필수)</h5>
            </div>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>한 카테고리 안에서 최대 2개까지 선택이 가능합니다</p>
            </div>
          </div>
          <div className="sectorWrap">
            {sector.map((item: SectorType, index: number) => {
              return (
                <div key={index}>
                  <div className="titleBadge">
                    <h4>{item.sector_name}</h4>
                  </div>
                  <div className="row">
                    {item.sector_list.map((subItem: SectorType, subIndex: number) => {
                      return (
                        <label key={subIndex} htmlFor={`subSector_${index}_${subIndex}`}>
                          <input
                            type="checkbox"
                            id={`subSector_${index}_${subIndex}`}
                            value={subItem.store_sector_id}
                            autoFocus={false}
                            checked={selectedSector.some(
                              (source) => source.store_sector_id === subItem.store_sector_id,
                            )}
                            onChange={() => handleCheckboxChange(subItem)}
                          />
                          {subItem.sector_name}
                        </label>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className={`submitButton ${selectedSector.length === 0 && 'inactive'}`}
            onClick={submitSector}>
            등록
          </button>
        </div>
      </Style>
    </>
  );
};

export default AdvertiseCategory;

const Style = styled.div`
  .inputText {
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
      }
      h4 {
        color: #555555;
      }
    }

    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .sectorWrap {
    display: flex;
    flex-direction: column;
    padding-top: 40px;
    gap: 20px;

    .titleBadge {
      padding: 8px 25px;
      background: #ecf5f3;
      border-radius: 5px;
      h4 {
        color: #555555;
      }
    }

    .row {
      padding: 20px 0;
      gap: 16px;
      flex-wrap: wrap;
    }
    label {
      display: flex;
      align-items: center;
      gap: 5px;
      color: #555555;
    }
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
`;
